// Parses Brazilian-formatted currency strings (1.000,50 → 1000.5) to a number.
export function parseMoney(
  value: string | number | null | undefined,
  returnZeroOnError = false,
): number | null {
  // If already a number, return it
  if (typeof value === "number") {
    return Number.isNaN(value) ? (returnZeroOnError ? 0 : null) : value;
  }

  // If null, undefined, or empty string
  if (value == null || String(value).trim() === "") {
    return returnZeroOnError ? 0 : null;
  }

  // Convert to string and clean
  const cleaned = String(value).trim();

  // Remove R$, spaces, and convert Brazilian format to US format
  // Remove: R$, spaces, and dots (thousands separator)
  // Replace: comma (decimal separator) with dot
  const normalizedValue = cleaned
    .replace(/[R$\s]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");

  const parsedValue = parseFloat(normalizedValue);

  if (Number.isNaN(parsedValue)) {
    return returnZeroOnError ? 0 : null;
  }

  return parsedValue;
}

// Parses a Brazilian-formatted currency string to a number, always returning a
// number (0 on a non-numeric value). Pass-through for numbers.
export const parseMoneyValue = (value: string | number): number => {
  if (typeof value === "number") return value;

  const normalizedValue = value.replace(/[R$\s.]/g, "").replace(",", ".");
  const parsedValue = parseFloat(normalizedValue);
  return isNaN(parsedValue) ? 0 : parsedValue;
};
